import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstanceh5xfupiitinz as Data_getInstance } from './adapter/DeletePlayerMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DeletePlayerMutation_VariablesAdapter_instance5p5r9tftkf9c as DeletePlayerMutation_VariablesAdapter_instance } from './adapter/DeletePlayerMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deletePlayer) {
        this.o6e_1 = deletePlayer;
      }
      toString() {
        return 'Data(deletePlayer=' + this.o6e_1 + ')';
      }
      hashCode() {
        return this.o6e_1 == null ? 0 : getBooleanHashCode(this.o6e_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.o6e_1 == other.o6e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.p6e_1 = '325dc987fdb63884ec22f9791902a751f93a10868d54c5276b03653e11ea6dc8';
        this.q6e_1 = 'deletePlayer';
      }
      u6d() {
        return 'mutation deletePlayer($input: DeletePlayerInput!) { deletePlayer(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DeletePlayerMutationClass;
function DeletePlayerMutation() {
  if (DeletePlayerMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.r6e_1 = input;
      }
      w6d() {
        return '325dc987fdb63884ec22f9791902a751f93a10868d54c5276b03653e11ea6dc8';
      }
      operationId() {
        return this.w6d();
      }
      v47() {
        return Companion_instance.u6d();
      }
      x6d() {
        return 'deletePlayer';
      }
      operationName() {
        return this.x6d();
      }
      p46(writer, customScalarAdapters, withDefaultValues) {
        DeletePlayerMutation_VariablesAdapter_instance.s6e(writer, this, customScalarAdapters, withDefaultValues);
      }
      o46() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'DeletePlayerMutation(input=' + this.r6e_1.toString() + ')';
      }
      hashCode() {
        return this.r6e_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePlayerMutation()))
          return false;
        if (!this.r6e_1.equals(other.r6e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePlayerMutation', VOID, VOID, [Mutation()]);
    DeletePlayerMutationClass = $;
  }
  return DeletePlayerMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data1yeuamf60pgqe,
  DeletePlayerMutation as DeletePlayerMutation1lewkfyyqx4x0,
};
//endregion

//# sourceMappingURL=DeletePlayerMutation.mjs.map
